var map = {
	"./ALanding/logo-second.png": 8280,
	"./DServices/1.png": 1943,
	"./DServices/2.png": 8901,
	"./DServices/3.png": 3031,
	"./DServices/4.png": 5038,
	"./ESay/arrow-ar.png": 2621,
	"./ESay/arrow-en.png": 6682,
	"./ESay/person.png": 8459,
	"./TheFooter/1.png": 3445,
	"./TheFooter/2.png": 4269,
	"./TheFooter/3.png": 3798,
	"./TheFooter/4.png": 2515,
	"./TheFooter/cloud-2.png": 5927,
	"./TheFooter/cloud-bg.png": 7282,
	"./TheFooter/cloud.png": 2392,
	"./TheFooter/facebook.png": 6130,
	"./TheHeader/links/contactus.png": 9700,
	"./TheHeader/links/facebook.png": 3284,
	"./TheHeader/links/home.png": 9976,
	"./TheHeader/links/project.png": 8380,
	"./TheHeader/logo.png": 810,
	"./TheHeader/mail.png": 5919,
	"./TheHeader/whatsapp.png": 1129,
	"./cover.png": 1362,
	"./scroll-to-top-not.png": 6365,
	"./scroll-to-top.png": 5762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1078;